import {autoserializeAs, autoserializeUsing} from "dcerialize";
import type {DateTime} from "luxon";
import {DateTimeSerializer} from "../helpers/DateSerializers";
import type {Existing} from "./base/IdentifiableModel";
import {SimpleUser} from "./users/User";

/**
 * @sealed
 */
export class Modification {
  @autoserializeUsing(DateTimeSerializer)
  public readonly at: DateTime<true>;
  @autoserializeAs(() => SimpleUser)
  public readonly by?: Readonly<Existing<SimpleUser>>;

  public get modifiedByText(): string {
    return this.by?.displayName ?? $localize`:@@modification-details.modified-by-system:the system`;
  }
}

/**
 * @sealed
 */
export class ModificationDetails {
  @autoserializeAs(() => Modification)
  public readonly creation: Readonly<Modification>;
  @autoserializeAs(() => Modification)
  public readonly update?: Readonly<Modification>;
}
